import Modal from '@/components/ui/Modal';
import { CycleDetail, CyclePayload } from '@/api/cyclesService';
import CycleSettingsForm from './CycleSettingsForm';

interface CycleModalProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (payload: CyclePayload) => Promise<CycleDetail>;
  onCreated: (cycle: CycleDetail) => void;
  isSaving: boolean;
  initial?: CycleDetail | null;
  resetToken?: unknown;
  title?: string;
  submitLabel?: string;
}

const CycleModal = ({
  open,
  onClose,
  onSubmit,
  onCreated,
  isSaving,
  initial = null,
  resetToken,
  title = 'Nouveau cycle',
  submitLabel = 'Créer',
}: CycleModalProps) => (
  <Modal open={open} onClose={onClose} size="xl" title={title}>
    <div className="max-h-[70vh] overflow-y-auto pr-1">
      <CycleSettingsForm
        initial={initial}
        isSaving={isSaving}
        resetToken={resetToken ?? open}
        submitLabel={submitLabel}
        onSubmit={onSubmit}
        onCancel={onClose}
        onSaved={(result) => {
          onClose();
          onCreated(result as CycleDetail);
        }}
      />
    </div>
  </Modal>
);

export default CycleModal;
